import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { Avatar } from '@mui/material';
import React from 'react';

import { avatarSx, ICON_SIZE } from './style';

export const MessageAvatar: React.FC<{ role: 'user' | 'assistant'; bgcolor: string }> = ({ role, bgcolor }) => (
  <Avatar sx={avatarSx(bgcolor)}>
    {role === 'assistant' ? (
      <FaceRetouchingNaturalIcon sx={{ fontSize: ICON_SIZE }} />
    ) : (
      <PersonOutlineIcon sx={{ fontSize: ICON_SIZE }} />
    )}
  </Avatar>
);
